var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3B5998"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.85 20.635h-3.544v12.981h-5.368V20.635h-2.553v-4.562h2.553V13.12c0-2.112 1.003-5.417 5.416-5.417l3.977.016v4.429h-2.885c-.474 0-1.14.236-1.14 1.243v2.685h4.013l-.47 4.558Z",
    fill: "#fff"
  })));
};
export default SvgFacebook;